import { PdfData } from "@/models/pdfData";
import { IconButton, Tooltip } from "@mui/material";
import { Videocam } from "@mui/icons-material";
import { NavLink } from "react-router-dom";
import React from "react";

const OpenChallengeViewButton: React.FC<{ storedGame: PdfData }> = ({
  storedGame,
}) => {
  return (
    <Tooltip title={"Challenge Ansicht"}>
      <NavLink
        to={`game/${storedGame.scope}/${storedGame.samsId}/challenge-view`}
      >
        <IconButton>
          <Videocam />
        </IconButton>
      </NavLink>
    </Tooltip>
  );
};

export default OpenChallengeViewButton;
